const firebaseConfig = {
    apiKey: 'AIzaSyDcmWSMtbI33Rvxa62SmlgBdEV10ZvaWOI',
    authDomain: 'e-hotel2.firebaseapp.com',
    projectId: 'e-hotel2',
    storageBucket: 'e-hotel2.appspot.com',
    messagingSenderId: '641741525246',
    appId: '1:641741525246:web:0ae0f848ecdf6e41f255af',
};

export default firebaseConfig;
